// OAuth redirect must match the current site; `window.location.origin` supports multiple domains in one build (register each in FusionAuth).
export function getOAuthRedirectUri() {
    if (typeof window !== "undefined" && window.location?.origin) {
        return window.location.origin;
    }
    return process.env.REACT_APP_FRONT_END_REDIRECT_URL || "";
}

export const config = {
    clientID: process.env.REACT_APP_CLIENT_ID,
    serverUrl: process.env.REACT_APP_SERVER_URL,
    get redirectUri() {
        return getOAuthRedirectUri();
    },
};


